import { BaseModal } from "../../../../components/common/BaseModal/BaseModal";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import { VMConfigurations } from "@4pace-cpq/core";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";

import { SaveConfigurationButton } from "./SaveConfigurationButton";

interface IExitConfigurationButton {
  configurationId: VMConfigurations["id"];
}
export const ExitConfigurationButton = ({
  configurationId,
}: IExitConfigurationButton): JSX.Element => {
  const { t } = useTranslation();
  /*  const api = useConfigurationApi();
  const sessionId = useSessionId(); */

  /*   const { mutate: setLineItemProperties } =
    useLineItemApiServicePutApiLineItemApiLineItemProperties();
 */
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  /* const { lineItemId } = useSearch({
    strict: false,
  }); */

  const handleCloseModal = (): void => {
    setIsModalOpen(false);
  };
  const handleOpenModal = (): void => {
    setIsModalOpen(true);
  };
  const handleExitConfiguration = (): void => {
    navigate({
      to: "/",
    });
  };

  /*   useEffect(() => {
    async function getProjectListInfo(): Promise<string> {
      const res = await api.invokeUserDefinedGetter({
        id: sessionId,
        name: "getProjectListInfo",
        invokeUserDefinedGetterParams: {
          path: "/XAS_PRODUCT_VIEW/0/",
          input: JSON.stringify({}),
        },
      });
      if (res?.output) {
        const data = JSON.parse(res?.output);
        setLineItemProperties({
          lineItemId: lineItemId,
          requestBody: {
            typeCode: data.typeCode,
            priceIndicator: data.priceIndicator,
          },
        });
        return res?.output;
      }
      return "";
    }

    getProjectListInfo();
  }, [setLineItemProperties, lineItemId, api, sessionId]); */

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpenModal}>
        {t("WEG:buttons.ExitConfigurationButton")}
      </Button>
      <BaseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={t("WEG:modal.ExitConfiguration.title")}
        customSx={{
          minWidth: "30em",
          width: "25%",
          overflow: "auto",
        }}
      >
        <Typography variant="caption">
          {t("WEG:modal.ExitConfiguration.note")}
        </Typography>
        <Box display="flex" gap={2} justifyContent="space-evenly" mt={2}>
          <SaveConfigurationButton
            configurationId={configurationId}
            label={t("WEG:buttons.SaveAndExitConfigurationButton")}
            callback={handleExitConfiguration}
          />
          <Button
            variant="outlined"
            color="primary"
            onClick={handleExitConfiguration}
          >
            {t("WEG:buttons.ExitWithoutSavingButton")}
          </Button>
        </Box>
      </BaseModal>
    </>
  );
};
